import React from 'react';
import { Search, X } from 'lucide-react';

const ListingFilters = ({ search, onSearchChange, statusFilter, onStatusChange }) => {
  return (
    <div className="flex flex-col sm:flex-row gap-3 mb-6">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
        <input
          type="text"
          placeholder="Pretraži po naslovu, prodavcu, emailu..."
          value={search}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="w-full pl-9 pr-9 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        {search && (
          <button
            onClick={() => onSearchChange('')}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
      <div className="flex gap-2">
        {['svi', 'aktivni', 'arhivirani']?.map((s) => (
          <button
            key={s}
            onClick={() => onStatusChange(s)}
            className={`px-4 py-2.5 rounded-lg text-sm font-medium capitalize transition-colors ${
              statusFilter === s
                ? 'bg-blue-600 text-white' :'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
            }`}
          >
            {s === 'svi' ? 'Svi' : s === 'aktivni' ? 'Aktivni' : 'Arhivirani'}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ListingFilters;
